/**
 * 成员进出记录页懒加载壳（14.27c；GroupMembersLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function GroupLogLazy({ groupId }: { groupId: number }) {
  const { mod } = useLazyModule(() => import('./GroupLogPage'));
  if (mod === null) return <div data-testid="group-log-loading-shell">加载中…</div>;
  return <mod.GroupLogPage groupId={groupId} />;
}
